import { render } from "./digitalAdvisor.vue?vue&type=template&id=079938fd&scoped=true&ts=true"
import script from "./digitalAdvisor.vue?vue&type=script&lang=ts"
export * from "./digitalAdvisor.vue?vue&type=script&lang=ts"

import "./digitalAdvisor.vue?vue&type=style&index=0&id=079938fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079938fd"]])

export default __exports__